import React
  from "react";

export const ErrorAlert = (props) => {
  return (
    <div className="wal-alert wal-alert-error">
      <div className="wal-alert-wrap">
        <div className="wal-alert-left">
          <div className="wal-alert-icon">
            <i className="icon-error-circle"></i>
          </div>
          <div className="wal-alert-message">
            <p>{props.translate("shared.error_label")}</p>
            <span>{props.message}</span>
          </div>
        </div>
        <div className="wal-alert-right">
          <div className="wal-alert-close">
            {/*<i className="icon-half-x"></i>*/}
          </div>
        </div>
      </div>
    </div>
  )
};

export default ErrorAlert;
